import { useMemo } from "react";
import { useAuth0 } from "../auth//react-auth0-wrapper";
import { PermissionType, RoleType } from "../dal/models";
export var usePermissions = function usePermissions() {
  var _useAuth = useAuth0(),
    siteRoles = _useAuth.siteRoles,
    allPermissions = _useAuth.allPermissions,
    isAdmin = _useAuth.isAdmin;
  var userPermissions = useMemo(function () {
    var permissions = new Set();
    var rolePermissionMap = new Map(allPermissions.map(function (permission) {
      return [permission.id, permission.name];
    }));
    siteRoles && siteRoles.forEach(function (userRole) {
      var _a;
      (_a = userRole.roles) === null || _a === void 0 ? void 0 : _a.forEach(function (role) {
        if (role.name === RoleType.SuperUser) {
          Object.values(PermissionType).forEach(function (perm) {
            return permissions.add(perm);
          });
          return;
        }
        role.permissions.forEach(function (permission) {
          var permissionName = rolePermissionMap.get(permission.id);
          if (permissionName) {
            permissions.add(permissionName);
          }
        });
      });
    });
    return permissions;
  }, [siteRoles, allPermissions, isAdmin]);
  var hasPermission = function hasPermission(requiredPermissions) {
    var permissionsToCheck = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
    return permissionsToCheck.some(function (permission) {
      return userPermissions.has(permission);
    });
  };
  var getAllowedPermissions = function getAllowedPermissions() {
    return Object.values(PermissionType).filter(function (permission) {
      return userPermissions.has(permission);
    });
  };
  return {
    hasPermission: hasPermission,
    getAllowedPermissions: getAllowedPermissions,
    permissions: Array.from(userPermissions)
  };
};